import { Injectable, inject } from '@angular/core'

import { Observable, of } from 'rxjs'

import { RuntimeApiService } from '@flowx/designer/shared/api/runtime.api'
import { InstanceDocument } from '@flowx/designer/shared/entities/instance-document.types'
import { GridSearchService } from '@flowx/designer/shared/services/grid-search.service'
import {
  PageRequest,
  PaginatedEndpoint,
  PaginatedResponse,
  Sort,
} from '@flowx/designer/shared/services/paginated-datasource'
import { UrlParametersStoreService } from '@flowx/designer/shared/services/url-parameters-store.service'

interface InstanceDocumentsQueryParams {
  processInstanceId: string
}

@Injectable({
  providedIn: 'root',
})
export class InstanceDocumentsService extends GridSearchService<InstanceDocumentsQueryParams> {
  #runtimeApi = inject(RuntimeApiService)
  #urlParametersStoreService = inject(UrlParametersStoreService)

  private initialQuery: Partial<InstanceDocumentsQueryParams> = {}

  getGridEndpointInfo(): {
    endpoint: PaginatedEndpoint<any, InstanceDocumentsQueryParams>
    sort: Sort
    query: Partial<InstanceDocumentsQueryParams>
  } {
    return {
      endpoint: this.getDocuments.bind(this),
      sort: {},
      query: this.initialQuery,
    }
  }

  getDocuments(
    params: PageRequest,
    query: Partial<InstanceDocumentsQueryParams>
  ): Observable<PaginatedResponse<InstanceDocument>> {
    const { appId } = this.#urlParametersStoreService.urlParameters

    if (!query.processInstanceId) {
      return of({
        content: [],
        last: true,
        totalElements: 0,
      } as PaginatedResponse<InstanceDocument>)
    }

    return this.#runtimeApi.getInstanceDocuments(appId, query.processInstanceId, {
      ...params,
    })
  }
}
